import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import PlanCard from '../../components/PlanCard';

const styles = css`
  padding:40px 0;
`;

function PlansResults({ plans, sort }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          {
            plans.length === 0 &&
              <p className="ResultsMessage">There are no plans available. Check your filters to see if you
                have previously chosen any criteria that may limit your results.</p>
          }
          {
            orderBy(plans, sort.field, get(sort, 'dir', 'asc')).map(plan => (
              <div key={plan._id} className="col-md-6  col-xl-4">
                <PlanCard plan={plan} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

PlansResults.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
};

export default withData(
  {
    plans: true,
  },
)(PlansResults);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlansResults.js